// extracted by mini-css-extract-plugin
export default {"visualizeWrapperContainer":"styles_visualizeWrapperContainer__tDGyX","iconsWrapper":"styles_iconsWrapper__KywpO","switchTab":"styles_switchTab__StWE3"};